import { appStateService } from '@logz-pkg/frontend-services';

export type NewApplicationState = {
  enabled: boolean;
  shouldHideNavigationModal: boolean;
};

const NEW_APPLICATION_SCHEMA_NAME = 'new-application';
const version = 0;

export const newApplicationStateService = {
  async getState(): Promise<NewApplicationState> {
    return appStateService.get(NEW_APPLICATION_SCHEMA_NAME, version);
  },

  async setState(state: Partial<NewApplicationState>) {
    const currentState = await this.getState();
    const newState: NewApplicationState = { ...currentState, ...state };

    if (Object.hasOwn(state, 'enabled') && currentState.enabled !== state.enabled) {
      newState.shouldHideNavigationModal = false;
    }

    return appStateService.set(NEW_APPLICATION_SCHEMA_NAME, newState);
  },

  async setEnabled(enabled: boolean) {
    return this.setState({ enabled });
  },
};
